import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState = {results:{}}

const reportsSlice = createSlice({
    name: "reports",
    initialState,
    reducers: {
        ReportsList: (state, action:PayloadAction<{}>) => {
            state.results = action.payload;
            return state;
        },
    },
});
export const selectReports= (state:any) => state.reports;
export const reportsActions = reportsSlice.actions;

export default reportsSlice.reducer;
